module.exports = __webpack_public_path__ + "img/20_126.c6f3136e.png";